import { Component, Input } from '@angular/core';
import { ReportTableColumn } from '../../../models';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrl: './report-table.component.scss',
})
export class ReportTableComponent {
  @Input() header: string;
  @Input() model: any[];
  @Input() bodyColumns: (any?) => ReportTableColumn[];
  @Input() bodySubTableColumnsProperty?: string;
  @Input() bodySubTableColumns?: (any?) => ReportTableColumn[];
  @Input() footerModel: any;
  @Input() footerColumns: (model: any) => ReportTableColumn[];
  @Input() footerSubTableColumnsProperty?: string;
  @Input() footerSubTableColumns?: (any?) => ReportTableColumn[];
  @Input() extraBoldLine = false;
  @Input() extraLineBreak = false;
  @Input() extraSubLineBreak = false;
  @Input()
  cssClass(column: ReportTableColumn): any {
    return {
      'width-small': column.widthSmall,
      'text-end': column.textRight,
      'text-center': column.textCenter,
      'text-nowrap': column.textRight || column.textCenter,
    };
  }
}
